exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1fE6p{padding-left:64px;padding-right:64px;padding-top:32px;-ms-flex:1 1 0%;flex:1 1 0%}._1UQ1M{max-width:1080px;width:100%;display:block;margin:0 auto}._3-bO4{padding-right:20px}.m3yp5{margin:0;padding:15px 0;position:relative;border-bottom:1px solid #dce0e0}._28iew{cursor:pointer;position:absolute;right:20px;font-size:20px;color:#bbb;display:none}.m3yp5:hover ._28iew{display:block}.QEnIW{font-weight:400;line-height:1}._3qCtj{margin-bottom:12px}@media screen and (max-width:640px){._2m7Zp{padding:0}}@media screen and (max-width:768px){._260QM{padding:0}}@media screen and (max-width:1024px){._28iew{position:relative;display:block;right:unset}}", ""]);

// exports
exports.locals = {
	"container": "_1fE6p",
	"landingContainer": "_1UQ1M",
	"panelSpace": "_3-bO4",
	"panelBody": "m3yp5",
	"iconRemove": "_28iew",
	"icon": "QEnIW",
	"space2": "_3qCtj",
	"listDetailContent": "_2m7Zp",
	"smPadding": "_260QM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/manageListing/ManageListing.css
// module id = 2625
// module chunks = 15